import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import {
  CityList,
  Eyebrow,
  Intro,
  IntroText,
  Panel,
  PrimaryCta,
  Step,
  StepIcon,
  StepList,
  StepText,
  StepTitle,
  Title,
} from './HowItWorks.styled';

/** Cities shown as "close to home" proof; NKY Connect serves all of Northern Kentucky. */
const CITIES = ['Covington', 'Florence', 'Fort Thomas', 'Newport', 'Independence', 'Erlanger'];

/** Steps mirror the guided service search: search → matched results → contact sheet. */
const STEPS = [
  {
    Icon: SearchRoundedIcon,
    title: 'Tell us what you need',
    text: 'Search for the job or tap a trade.',
  },
  {
    Icon: FactCheckRoundedIcon,
    title: 'See matched local pros',
    text: 'Compare prices, availability, and ratings. No sign-up needed.',
  },
  {
    Icon: ForumRoundedIcon,
    title: 'Contact the one you pick',
    text: 'Call or request a quote. Your info goes only to that pro.',
  },
];

/** Home page "How it works" panel for homeowners. */
const HowItWorks = () => (
  <Panel aria-labelledby="how-it-works-title">
    <Intro>
      <Eyebrow>How it works</Eyebrow>
      <Title id="how-it-works-title">The right local pro in three easy steps</Title>
      <IntroText>
        NKY Connect only lists Northern Kentucky businesses, so every match is close to home.
      </IntroText>
      <CityList aria-label="Some of the cities we serve">
        {CITIES.map((city) => (
          <li key={city}>{city}</li>
        ))}
        <li>and more</li>
      </CityList>
      <PrimaryCta component={RouterLink} to="/services">
        Find a pro
      </PrimaryCta>
    </Intro>

    <StepList>
      {STEPS.map(({ Icon, title, text }, index) => (
        <Step key={title}>
          <StepIcon aria-hidden>
            <Icon />
          </StepIcon>
          <div>
            <StepTitle>
              {index + 1}. {title}
            </StepTitle>
            <StepText>{text}</StepText>
          </div>
        </Step>
      ))}
    </StepList>
  </Panel>
);

export default HowItWorks;
